import React, { useState, useEffect } from 'react';

import { onAuthStateChanged, signInWithEmailAndPassword } from 'firebase/auth';

import { auth } from '../firebase';
//import { loadObserver } from '../lib2/observer';

const LocaleProviderCtx = React.createContext();
export const useLocaleProviderCtx = () => React.useContext(LocaleProviderCtx);
//const auth = getAuth();

export const LocaleProvider = ({ children }) => {
  const lang = 'en'; //i18n.language;

  /*useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/auth.user
        const uid = user.uid;
        //console.clear();
        //console.log(user);
        // ...
      } else {
        // User is signed out
        // ...
        signInWithEmailAndPassword(auth, 'rs@gmail.com', 'rs@gmail.com')
          .then((userCredential) => {
            // Signed in
            const user = userCredential.user;
            // ...
            //console.clear();
            //console.log(user);
          })
          .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
          });
      }
    });
  }, []);*/

  return (
    <LocaleProviderCtx.Provider
      value={{
        lang,
      }}
    >
      {children}
    </LocaleProviderCtx.Provider>
  );
};
